module.exports = __webpack_public_path__ + "img/qrcode_degustacao.f3ce5aa1.png";